import styled from 'styled-components';

const StyledButtonMap = styled('button')`
  padding-left: 0.2rem;
  color: #3400a6;
  border: none;
`;

export default StyledButtonMap;
